module.exports = __webpack_public_path__ + "img/9791186294093.394f00bb.jpg";